import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext } from 'next';
import { getDefaultStaticProps } from '@/utils/next';
import { BoardLandingPageView } from './BoardLandingPageView';
export default function BoardLandingPage() {
  return <BoardLandingPageView data-sentry-element="BoardLandingPageView" data-sentry-component="BoardLandingPage" data-sentry-source-file="index.page.tsx" />;
}
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  // 이 페이지의 문구는 전부 'boardLanding' 네임스페이스다. 'common' 은
  // `getDefaultStaticProps` 가 기본으로 넣어 주고(Footer 가 쓴다) 명시하지 않는다.
  return getDefaultStaticProps({
    locale,
    namespaces: ['boardLanding']
  });
};